import type { PropsWithChildren } from "react";

// Status pills shared by the human-in-the-loop tool cards, shown in place of the
// real card. `HitlPending` covers "args still streaming"; `HitlLoadError` covers
// "args settled but unparseable". The subject copy stays caller-supplied so each
// card names its own thing (approval / ingest / question) while the styling is
// single-sourced here.

export function HitlPending({ children }: PropsWithChildren) {
  return (
    <div className="rounded-lg border border-border bg-background px-3 py-2 text-xs text-muted-foreground">
      {children}
    </div>
  );
}

export function HitlLoadError({ children }: PropsWithChildren) {
  return (
    <div className="rounded-lg border border-destructive/30 bg-destructive/[0.06] px-3 py-2 text-xs text-destructive">
      {children}
    </div>
  );
}
